import { render, staticRenderFns } from "./CancellationInsights.vue?vue&type=template&id=32b1eb22&"
import script from "./CancellationInsights.vue?vue&type=script&lang=ts&"
export * from "./CancellationInsights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports